/**
 * Модель для работы со сводными данными
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import UsersService from '../services/UsersService';

interface IState {
  usersTotal: number;
}

const initialState: IState = {
  usersTotal: 0
};

export const infrastructureMain = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setUsersTotal(state: IState, payload: number): IState {
      return {
        ...state,
        usersTotal: payload
      };
    }
  },
  effects: () => ({
    async getUsersTotal() {
      const {
        data: { total }
      } = await UsersService.getAllEmployees({ pageSize: 1 });

      this.setUsersTotal(total);
    }
  })
});
